import { render, staticRenderFns } from "./MarkingsAssignListItem.vue?vue&type=template&id=f436f2d0&scoped=true"
import script from "./MarkingsAssignListItem.vue?vue&type=script&lang=js"
export * from "./MarkingsAssignListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f436f2d0",
  null
  
)

export default component.exports